// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__14-jP","buttons":"PendingPaymentAlert_buttons__1R0nV"};